import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import BackgroundImage from 'features/background-image'
import Hero from './components/hero'
import Intro from './components/intro'
import Benefits from './components/benefits'
import Requirements from './components/requirements'
import Faq from './components/faq'

interface Props {
    hero: SectionType
    intro: SectionType
    benefits: SectionType
    requirements: SectionType
    guidelines: SectionType
    faq: SectionType
}

const PartnershipProgram = ({
    hero,
    intro,
    benefits,
    requirements,
    guidelines,
    faq,
}: Props): JSX.Element => (
    <BackgroundImage url="https://images.ctfassets.net/7lhcm73ukv5p/1mv6Tg8PUsMWyGauWckSOo/5be5f00d5fb6d445f420b7a1c669fd26/star-bg.jpg">
        {hero && <Hero section={hero} />}
        {intro && <Intro section={intro} />}
        {benefits && <Benefits section={benefits} />}
        {requirements && guidelines && (
            <Requirements section={requirements} guidelines={guidelines} />
        )}
        {faq && <Faq section={faq} />}
    </BackgroundImage>
)

export default PartnershipProgram
